import * as stylex from '@stylexjs/stylex'
import { colors } from '../tokens/colors.stylex'

export const aquaColors = {
  brand: '#006CB8',
  primary50: '#F7FDFF',
  primary100: '#E8F9FF',
  primary200: '#AFDEF1',
  primary300: '#7CC2E3',
  primary400: '#4DA5D4',
  primary500: '#2488C6',
  primary600: '#006CB8',
  primary700: '#00569D',
  primary800: '#004382',
  primary900: '#003267',

  secondary50: '#F7FDFF',
  secondary100: '#E8F9FF',
  secondary200: '#AFDEF1',
  secondary300: '#7CC2E3',
  secondary400: '#4DA5D4',
  secondary500: '#2488C6',
  secondary600: '#006CB8',
  secondary700: '#00569D',
  secondary800: '#004382',
  secondary900: '#003267',
}

export const colorTheme = stylex.createTheme(colors, aquaColors)
